module.exports = __webpack_public_path__ + "img/r-125.67da82c8.jpg";